import { TableComponent } from '@labrav/react-components'
import React from 'react'

export type SubscriptionTableProps = {
  mapping: Record<string, string>
  customObject: Record<string, string | JSX.Element | null>[]
}

export const SubscriptionTable = React.memo(
  ({ mapping, customObject }: SubscriptionTableProps) => {
    const noOp = () => void 0
    return (
      <div data-testid="subscription-dimensions">
        <TableComponent
          mapping={mapping}
          objects={customObject}
          component="div"
          hidePagination={true}
          onChange={() => null}
          onClick={() => null}
          onChangeRowsPerPage={noOp}
          noHover={true}
          rowsPerPageOptions={[]}
          pageNumber={0}
          count={0}
          rowsPerPage={0}
        />
      </div>
    )
  }
)
